import type { ServerColDef } from '@cmg/data-grid';
import {
  traitDetailAccountTypeSelector,
  traitDetailNameSelector,
  traitDetailSubdomainSelector,
} from '@cmg/e2e-selectors';
import React from 'react';
import { Link } from 'react-router-dom';

import routeFactory from '../../../../../common/util/routeFactory';
import type { Account } from '../../../../../types/domain/account/account';
import { accountTypeLabels } from '../../../../../types/domain/account/constants';

export const NameCellRenderer: React.FC<{ data: Account }> = ({ data: account }) => (
  <Link
    to={routeFactory.accountDetail.getUrlPath({
      accountSubdomain: account.subdomain,
    })}
    data-testid={traitDetailNameSelector}
  >
    {account.name}
  </Link>
);

export const AccountTypeCellRenderer: React.FC<{ data: Account }> = ({ data: account }) => (
  <span data-testid={traitDetailAccountTypeSelector.testId}>
    {account.accountType ? accountTypeLabels[account.accountType] : 'None'}
  </span>
);

export const SubdomainRenderer: React.FC<{ data: Account }> = ({ data }) => {
  return <span data-testid={traitDetailSubdomainSelector.testId}>{data.subdomain}</span>;
};

const columns: ServerColDef<Account>[] = [
  {
    field: 'name',
    headerName: 'Name',
    cellRenderer: NameCellRenderer,
    filter: false,
  },
  {
    field: 'subdomain',
    headerName: 'Subdomain',
    cellRenderer: SubdomainRenderer,
    filter: false,
  },
  {
    field: 'accountType',
    headerName: 'Account Type',
    cellRenderer: AccountTypeCellRenderer,
    filter: false,
  },
];

export default columns;
